<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 96 960 960"
    width="24"
    fill="currentColor"
  >
    <path
      d="M109 936q-11 0-20-5.5T75 916q-5-9-5.5-19.5T75 876l370-640q6-10 15.5-15t19.5-5q10 0 19.5 5t15.5 15l370 640q6 10 5.5 20.5T885 916q-5 9-14 14.5t-20 5.5H109Zm69-80h604L480 336 178 856Zm302-40q17 0 28.5-11.5T520 776q0-17-11.5-28.5T480 736q-17 0-28.5 11.5T440 776q0 17 11.5 28.5T480 816Zm0-120q17 0 28.5-11.5T520 656V536q0-17-11.5-28.5T480 496q-17 0-28.5 11.5T440 536v120q0 17 11.5 28.5T480 696Zm0-100Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Error'
  }
</script>
